import { render, staticRenderFns } from "./LensIcon.vue?vue&type=template&id=fb4856be&"
import script from "./LensIcon.vue?vue&type=script&lang=ts&"
export * from "./LensIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports